import React,{PureComponent} from 'react'
import styled from 'styled-components'
import { WHITE, YELLOW, BLUE } from '../colors';

const StyledButton = styled.button`
    color:${WHITE};
    background:${({secondary})=>secondary ? BLUE : YELLOW};
    border-radius:40px;
    height:40px;
    display:flex;
    font-size:15px;
    justify-content:center;
    align-items:center;
    padding: 0 20px;
    border:none;
    cursor:pointer;
    & > *{
        text-decoration:none;
    }
    svg{
        margin-right:5px;
        display:inline-block;
    }
`

export default class Button extends PureComponent{
    render(){
        return <StyledButton {...this.props}>{this.props.children}</StyledButton>
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/button.js